module.exports = __webpack_public_path__ + "img/dxsz_logo.png";